import { baseStoreCreator } from '@/utils/store';

import { VerificationType } from '../verification.types';

export interface VerificationState {
  verificationChannels: VerificationType[];
}

export const DEFAULT_VALUES: VerificationState = {
  verificationChannels: [],
};

export const useVerificationStore = baseStoreCreator<VerificationState>(DEFAULT_VALUES);

export default useVerificationStore;
